import PropTypes from 'prop-types';
import { Icon } from "../Icon/Icon";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-modal .overlay {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 10;\n}\n.kof-modal .box {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 50%;\n  z-index: 11;\n}\n.kof-modal .box .head {\n  display: flex;\n  justify-content: end;\n  padding: 8px 0;\n}\n.kof-modal .box .head .close {\n  fill: white;\n}\n.kof-modal .box .content {\n  background: white;\n  border-radius: 2px;\n  padding: 16px;\n  overflow: auto;\n  max-height: 600px;\n}";
  const fileName = "Modal_Modal_8a1a0f4c-6d5e-43d4-a229-19e4ba7f1508";
  const element = document.querySelector("style[data-sass-component='Modal_Modal_8a1a0f4c-6d5e-43d4-a229-19e4ba7f1508']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Modal(props) {
  if (props.isOpen === false) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: 'kof-modal',
    children: [/*#__PURE__*/_jsx("div", {
      className: 'overlay',
      onClick: props.onClose
    }), /*#__PURE__*/_jsxs("div", {
      className: 'box',
      children: [/*#__PURE__*/_jsx("div", {
        className: 'head',
        children: /*#__PURE__*/_jsx(Icon, {
          type: 'close',
          className: 'close',
          onClick: props.onClose
        })
      }), /*#__PURE__*/_jsx("div", {
        className: 'content',
        children: props.children
      })]
    })]
  });
}
Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
};
export { Modal };